import defaultState from './defaultState'

const unwrapState = state => state.results || defaultState

/**
 * The size of high quality results. While loading results it is null.
 * @param state
 * @return {number|null}
 */
export const getResultsHighQualitySize = (state) => unwrapState(state).highQualitySize
/**
 * Returns list of results. While loading results it is null.
 * @param state
 * @return {null|Array}
 */
export const getResultsList = (state) => unwrapState(state).list
/**
 * Are the results currently loading
 * @param state
 * @return {boolean}
 */
export const getResultsLoading = (state) => unwrapState(state).loading
/**
 * The size of low quality results. While loading results it is null.
 * @param state
 * @return {number|null}
 */
export const getResultsLowQualitySize = (state) => unwrapState(state).lowQualitySize
/**
 * True if loading next page of results.
 * @param state
 * @return {boolean}
 */
export const getResultsNextLoading = (state) => unwrapState(state).nextLoading
/**
 * Search parameters for next page request. null if no next page
 * @param state
 * @return {Object|null}
 */
export const getResultsNextParams = (state) => unwrapState(state).nextParams
/**
 * Available order options
 * @returns {string[]} list of available order options
 */
export const getResultsOrderOptions = (state) => unwrapState(state).orderOptions
/**
 * Search params used to retrieve the results
 * @param state
 * @return {Object}
 */
export const getResultsSearchParams = (state) => unwrapState(state).searchParams
export const getResultsSearchType = (state) => getResultsSearchParams(state).type
/**
 * The total size of results. While loading results it is null.
 * @param state
 * @return {number|null}
 */
export const getResultsTotalSize = (state) => unwrapState(state).totalSize
/**
 * True if next page of results can be requested
 * @param state
 * @return {boolean}
 */
export const getResultsHasMorePages = (state) => {
  const count = getResultsTotalSize(state)
  const list = getResultsList(state)
  // defaults to 0 when loading or if missing for whatever reason
  const { offset = 0 } = getResultsNextParams(state) || {}

  // if no list - we must be still loading the results,
  // so we can't request next page
  if (list == null) return false

  // if list has all items - no next pages
  if (list.length >= count) return false

  return offset < count
}
/**
 * True if results has items with mixed quality
 * @param state
 * @return {boolean}
 */
export const getResultsHasMixedQuality = (state) => {
  const highQualitySize = getResultsHighQualitySize(state)
  const lowQualitySize = getResultsLowQualitySize(state)

  if (highQualitySize && lowQualitySize) {
    return true
  }

  return false
}

export const getResultsHasMultiplePages = (state) => unwrapState(state).hasMultiplePages
export const getResultParams = (state) => unwrapState(state).resultParams
